import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import "./Login.css";
import Footer from "../components/Footer";

import bgVideo from "../assets/bgVideo.mp4";
import leftLogo from "../assets/ciallogo.png";
import rightLogo from "../assets/krrlogo.jpg";

const API_URL = process.env.REACT_APP_API_URL;

function ForgotPassword() {

    const [usernameOrEmail, setUsernameOrEmail] = useState("");

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {

        e.preventDefault();

        setIsSubmitting(true);

        try {

            const res = await fetch(`${API_URL}/portal/forgot-password`, {

                method: "POST",

                headers: { "Content-Type": "application/json" },

                body: JSON.stringify({ username_or_email: usernameOrEmail })

            });

            const data = await res.json();

            if (data.status) {

                setSubmitted(true);

            } else {

                toast.error(data.message || "Something went wrong.");

            }

        } catch (err) {

            toast.error("Could not reach the server. Please try again.");

        } finally {

            setIsSubmitting(false);

        }

    };

    return (
        <div className="login-page">

            <video
                className="background-video"
                autoPlay
                muted
                loop
                playsInline
            >
                <source src={bgVideo} type="video/mp4" />
            </video>

            <div className="video-overlay"></div>

            {/* Top Logos */}
            <div className="top-header">

                <img
                    src={leftLogo}
                    alt="CIAL Logo"
                    className="header-logo left-logo"
                />

                <img
                    src={rightLogo}
                    alt="KRR Logo"
                    className="header-logo right-logo"
                />

            </div>

            <div className="login-container">

                <div className="login-card">

                    <h2>Forgot Password</h2>

                    {submitted ? (

                        <div className="form-group">

                            <p>
                                If an account matches that username/email, a password
                                reset link has been sent to it. Please check your inbox
                                (and spam folder) and click the link to set a new password.
                            </p>

                            <Link to="/login" className="login-btn" style={{ display: "block", textAlign: "center", textDecoration: "none" }}>
                                Back to Login
                            </Link>

                        </div>

                    ) : (

                        <form onSubmit={handleSubmit}>

                            <div className="form-group">

                                <label>Username or Email</label>

                                <input
                                    type="text"
                                    value={usernameOrEmail}
                                    onChange={(e) => setUsernameOrEmail(e.target.value)}
                                    required
                                    disabled={isSubmitting}
                                />

                            </div>

                            <button type="submit" className="login-btn" disabled={isSubmitting}>
                                {isSubmitting ? "Sending..." : "Send Reset Link"}
                            </button>

                            <Link to="/login" className="forgot-password-link">
                                Back to Login
                            </Link>

                        </form>

                    )}

                </div>

            </div>

            <Footer transparent />

        </div>
    );

}

export default ForgotPassword;
